import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, alpha, hexToRgb, useTheme } from "@mui/material";
import { MenuItem } from "@sal/onevent-portal";
import { useAuth } from "@sal/authentication.react";
import { useLocation } from "react-router-dom";
import { VerticalNavigationComponentProps } from "./VerticalNavigation";
import React from "react";

export interface VerticalMenuProps extends VerticalNavigationComponentProps {
	items: Array<MenuItem>;
	menuItemsStyles?: React.CSSProperties;
	mode?: "light" | "dark";
}

export function VerticalMenu({ items, collapsed, menuItemsStyles, mode = "dark" }: VerticalMenuProps) {
	const auth = useAuth();
	const theme = useTheme();
	const location = useLocation();
	const backgroundColor = mode === "dark" ? "#12242F" : theme.palette.primary.light;

	return (
		<List
			disablePadding
			sx={{
				display: "flex",
				flexDirection: "column",
				gap: 3
			}}
		>
			{items
				.filter((x) => auth.userHasPermission(x.securityContext, x.securityContextPermission))
				.map((item) => {
					const parts = item.path.split("?");
					const [path] = parts;
					const active = path === location.pathname;

					return (
						<ListItem key={item.path} disablePadding>
							<ListItemButton
								disableGutters
								sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									gap: 6,
									paddingX: theme.spacing(collapsed ? 0 : 6),
									borderRadius: theme.shape.borderRadius * 2,
									backgroundColor: active ? hexToRgb(backgroundColor) : "initial",
									"&:hover": {
										backgroundColor: alpha(
											hexToRgb(theme.palette.primary.light),
											Number(menuItemsStyles?.opacity ?? 0)
										)
									}
								}}
								onClick={() => {
									const url = `${item.isExternalURL ? "" : "/#"}${item.path}`;
									item.openNewTab ? window.open(url) : (window.location.href = url);
								}}
							>
								{item.icon && (
									<ListItemIcon
										title={item.label}
										sx={{
											minWidth: "initial",
											fontSize: "1.35rem",
											color: menuItemsStyles?.color ?? theme.palette.primary.main
										}}
									>
										{item.icon}
									</ListItemIcon>
								)}
								{!collapsed && (
									<ListItemText
										primary={item.label}
										sx={{
											color: menuItemsStyles?.color ?? theme.palette.primary.main
										}}
										primaryTypographyProps={{
											fontSize: "1rem",
											fontWeight: 400
										}}
									/>
								)}
							</ListItemButton>
						</ListItem>
					);
				})}
		</List>
	);
}

export default VerticalMenu;
